const exportPanel = {
  en: {
    exportPanel: {
      descJson: "Raw data for developers",
      descCsv: "Spreadsheet compatible",
      descXlsx: "Microsoft Excel format",
      descPdf: "Printable report",
      exportFailed: "Export failed",
      exportSuccessful: "Export successful",
      downloaded: "Downloaded {{filename}}",
      export: "Export",
      exportFormat: "Export Format",
      exportData: "Export Data",
      exportTitle: "Export Analytics Data",
      descAll: "Choose a format to export all analytics data",
      descType: "Choose a format to export {{type}} data",
      lastDays: "Export includes data from the last {{days}} days",
      exportComplete: "Export complete"
    }
  },
  fr: {
    exportPanel: {
      descJson: "Données brutes pour les développeurs",
      descCsv: "Compatible avec les tableurs",
      descXlsx: "Format Microsoft Excel",
      descPdf: "Rapport imprimable",
      exportFailed: "Échec de l'exportation",
      exportSuccessful: "Exportation réussie",
      downloaded: "{{filename}} téléchargé",
      export: "Exporter",
      exportFormat: "Format d'exportation",
      exportData: "Exporter les données",
      exportTitle: "Exporter les données d'analyse",
      descAll: "Choisissez un format pour exporter toutes les données d'analyse",
      descType: "Choisissez un format pour exporter les données {{type}}",
      lastDays: "L'exportation inclut les données des {{days}} derniers jours",
      exportComplete: "Exportation terminée"
    }
  }
};

export default exportPanel;
